import React, { useState } from "react";
import { connect } from "react-redux";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Modal,
  Grid,
  TextField,
  Backdrop,
  Button,
  Typography,
} from "@mui/material";
import { makeStyles } from '@mui/styles';
import {
  addCustomLicense,
  updateCustomLicense,
  clearAllCustomLicenseMessages,
} from "../store/actions";

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "whitesmoke",
  },
  activeButton: {
    color: "white", // change this to the desired active color
    marginLeft: "auto", // This will push the link to the right
    textDecoration: "none", // Remove text decoration from the link
  },
  logo: {
    maxWidth: 160,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowY: "auto" /* Enable vertical scrolling */,
    maxHeight: "80vh" /* Set a maximum height to limit scrolling */,
    maxWidth: "80vw" /* Set a maximum height to limit scrolling */,
  },
  button: {
    marginTop: theme.spacing(2),
  },
  // formControl: {
  //   margin: theme.spacing(1),
  //   minWidth: 120,
  // },
}));

const CustomLicenseAddEditModal = (props) => {
  console.log("Custom License Add Edit Modal, props: ", props);
  const { mode } = props;
  const classes = useStyles();
  const customLicenseParameters = [
    { name: "Price", type: "number", field: "text" },
    { name: "Description", type: "text", field: "text" },
    { name: "Number Of Assets", type: "number", field: "text" },
    { name: "Scan Frequency", type: "number", field: "select" },
    { name: "Security Posture", type: "number", field: "select" },
    { name: "Support Response", type: "number", field: "select" },
  ];

  const customLicenseAddOnsParameters = props.license["Add ons"].map(
    (addOn) => addOn.Name
  );

  const customLicenseComplianceAddOnsParameters = props.license[
    "Compliance Add Ons"
  ].map((addOn) => addOn.Name);

  const [customLicense, setCustomLicense] = useState(props.license);

  console.log(
    "customLicenseAddOnsParameters : ",
    customLicenseAddOnsParameters
  );
  console.log(
    "customLicenseComplianceAddOnsParameters",
    customLicenseComplianceAddOnsParameters
  );

  const handleModalClose = () => {
    props.setOpen(false);
  };

  const handleSubmit = () => {
    if (mode === "add") {
      delete customLicense["Security Posture"];
      console.log("Submitted data for add account:", customLicense);
      props.addCustomLicense(customLicense);
    } else {
      delete customLicense["Security Posture"];
      console.log("Submitted data for update account:", customLicense);
      props.updateCustomLicense(customLicense);
    }
  };

  const handleFieldChange = (category, fieldName, value) => {
    console.log(
      "Field changed for category: ",
      category,
      " fieldName=",
      fieldName,
      " value=",
      value
    );
    setCustomLicense((prevState) => {
      if (category === "add-ons") {
        const updatedAddOns = prevState["Add ons"].map((addOn) => {
          if (addOn.Name === fieldName) {
            return { ...addOn, Price: value };
          }
          return addOn;
        });
        return { ...prevState, "Add ons": updatedAddOns };
      } else if (category === "compliance-add-ons") {
        const updatedComplianceAddOns = prevState["Compliance Add Ons"].map(
          (addOn) => {
            if (addOn.Name === fieldName) {
              return { ...addOn, Price: value };
            }
            return addOn;
          }
        );
        return { ...prevState, "Compliance Add Ons": updatedComplianceAddOns };
      }
      // For custom license parameters
      return { ...prevState, [fieldName]: value };
    });
  };

  console.log("############ customLicense : ", customLicense);

  return (
    <Modal
      className={classes.modal}
      open={props.isOpen}
      onClose={handleModalClose}
      BackdropComponent={Backdrop}
    >
      <div className={classes.paper}>
        <h3>{mode === "add" ? "Add " : "Edit "}Custom License</h3>
        <Grid container spacing={2}>
          {/* Render custom license parameters */}
          {customLicenseParameters.map((param) => (
            <Grid item xs={12} sm={6} lg={4} key={param.name}>
              {param.field === "text" ? (
                <TextField
                  label={param.name}
                  type={param.type}
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={customLicense[param.name]}
                  onChange={(e) =>
                    handleFieldChange("parameters", param.name, e.target.value)
                  }
                />
              ) : (
                <NumberDropdown
                  label={param.name}
                  value={
                    param.name === "Security Posture"
                      ? customLicense["Scan Frequency"]
                      : customLicense[param.name]
                  }
                  onChange={(e) =>
                    handleFieldChange("parameters", param.name, e.target.value)
                  }
                />
              )}
            </Grid>
          ))}
        </Grid>
        <br />
        <Typography>Add Ons</Typography>
        <br />
        <Grid container spacing={2}>
          {/* Render add-ons parameters */}
          {customLicenseAddOnsParameters.map((addOn) => (
            <Grid item xs={12} sm={6} lg={4} key={addOn}>
              <TextField
                label={addOn}
                fullWidth
                variant="outlined"
                size="small"
                value={
                  customLicense["Add ons"].find((item) => item.Name === addOn)
                    .Price
                }
                onChange={(e) =>
                  handleFieldChange("add-ons", addOn, e.target.value)
                }
              />
            </Grid>
          ))}
        </Grid>
        <br />
        <Typography>Compliance Add Ons</Typography>
        <br />
        <Grid container spacing={2}>
          {/* Render compliance add-ons parameters */}
          {customLicenseComplianceAddOnsParameters.map((addOn) => (
            <Grid item xs={12} sm={6} lg={2} key={addOn}>
              <TextField
                label={addOn}
                fullWidth
                variant="outlined"
                size="small"
                value={
                  customLicense["Compliance Add Ons"].find(
                    (item) => item.Name === addOn
                  ).Price
                }
                onChange={(e) =>
                  handleFieldChange("compliance-add-ons", addOn, e.target.value)
                }
              />
            </Grid>
          ))}
        </Grid>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={handleSubmit}
          disabled={
            props.isAddingCustomLicense || props.isUpdatingCustomLicense
          }
        >
          {mode === "add" ? "Add Custom License" : "Update Custom License"}
        </Button>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  const {
    isAddingCustomLicense,
    addCustomLicenseError,
    addCustomLicenseMessage,

    isUpdatingCustomLicense,
    updateCustomLicenseError,
    updateCustomLicenseMessage,
  } = state.customLicense;

  return {
    isAddingCustomLicense,
    addCustomLicenseError,
    addCustomLicenseMessage,

    isUpdatingCustomLicense,
    updateCustomLicenseError,
    updateCustomLicenseMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addCustomLicense: (customLicense) => {
      dispatch(addCustomLicense(customLicense));
    },
    updateCustomLicense: (customLicense) => {
      dispatch(updateCustomLicense(customLicense));
    },
    clearAllMessages: () => {
      dispatch(clearAllCustomLicenseMessages());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomLicenseAddEditModal);

const NumberDropdown = ({ label, value, onChange }) => {
  const numbers = Array.from({ length: 24 }, (_, index) => index + 1);

  return (
    <FormControl fullWidth>
      <InputLabel id={`${label}-select-label`}>{label}</InputLabel>
      <Select
        type="select"
        label={label}
        labelId={`${label}-select-label`}
        id={`${label}-select`}
        value={value}
        onChange={onChange}
        variant="outlined"
        size="small"
        name={label}
        disabled={label === "Security Posture"}
      >
        {numbers.map((number) => (
          <MenuItem
            key={number}
            value={
              label === "Support Response"
                ? `Within ${number} hrs`
                : `Every ${number} Hours`
            }
          >
            {label === "Support Response"
              ? `Within ${number} hrs`
              : `Every ${number} Hours`}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
